module.exports = __webpack_public_path__ + "static/media/352.7a8b2c50.png";